<template>
  <div class="evaluation-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>运动测评</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="time-screen">
      <el-tag :effect="time_name ===item.value? 'light':'plain'"
              v-for="(item,index) in time_list"
              @click="checkTime(item)"
              :key="index"
      >{{item.name}}</el-tag>
      <div class="time">
        <el-date-picker
          v-model="time_slot"
          size="small"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <el-button type="primary" size="small"  @click.native="Query_1">确认</el-button>
      <el-button type="success" size="small" @click="downloadRecord">导出记录</el-button>
    </div>
    <div class="list">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        size="small"
      >
        <el-table-column
          fixed
          prop="user_name"
          label="用户名"
          width="180">
        </el-table-column>
        <el-table-column
          prop="height"
          label="身高（cm）">
        </el-table-column>
        <el-table-column
          prop="weight"
          label="体重（kg）">
        </el-table-column>
        <el-table-column
          prop="sitting_count"
          label="30s坐站测试（次）">
        </el-table-column>
        <el-table-column
          prop="arm_count_l"
          label="30s手臂弯举(左手)（次）">
        </el-table-column>
        <el-table-column
          prop="arm_count_r"
          label="30s手臂弯举(右手)（次）">
        </el-table-column>

        <el-table-column
          prop="mark_time_count"
          label="两分钟的踏步（次）">
        </el-table-column>
        <el-table-column
          prop="sit_and_reach_l"
          label="椅式坐位体前屈(左)（CM）">
        </el-table-column>
        <el-table-column
          prop="sit_and_reach_r"
          label="椅式坐位体前屈(右)（CM）">
        </el-table-column>
        <el-table-column
          prop="claw_l"
          label="背抓(左)（CM）">
        </el-table-column>
        <el-table-column
          prop="claw_r"
          label="背抓(右)（CM）">
        </el-table-column>
        <el-table-column
          prop="walk244"
          label="2.44m起立行走测试（毫秒）">
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="c_time"
          label="答题时间"
        width="200">
        </el-table-column>
      </el-table>
    </div>

    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>


<script>
  export default {
    name:'EvaluationList',
    data() {
      return {
        pages:1,
        limit: 10,
        time_slot: ['',''],
        time_name: '',
        start_time: '',
        end_time: '',
        time_list:[
          {name:'今天',value:'today'},
          {name:'昨天',value:'yesterday'},
          {name:'近7天',value:'week'},
          {name:'近30天',value:'month'}
        ],
        tableData: [],
        total:0,
        timeName: '',
      }
    },
    methods: {
      getEvaluationList(){
        this.$get('/v1/sport-evaluation?pages=' + this.pages + '&limit=' + this.limit+ '&time_name=' + this.time_name + '&start_time=' + this.start_time + '&end_time=' + this.end_time, {})
          .then((res) => {
            if (res.data.status === 'success') {
              this.tableData = res.data.data.data;
              this.total = res.data.data.total;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      Query_1(){
        this.pages = 1;
        this.time_name = '';
        this.start_time= this.time_slot[0];
        this.end_time= this.time_slot[1];
        this.getEvaluationList();
      },
      checkTime(item) {
        console.log(item.name,item.value)
        this.timeName = item.name
        this.start_time= '';
        this.end_time= '';
        this.time_slot = ['',''];
        this.time_name = item.value;
        this.getEvaluationList();
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex %2 === 1) {
          return '';
        } else {
          return 'success-row';
        }
      },
      handleSizeChange(val) {
        this.limit = val;
        this.getEvaluationList()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.pages = val;
        this.getEvaluationList()
        console.log(`当前页: ${val}`);
      },
      goTo(path,user_id,name){
        this.$router.push({
          path:path,
          query:{
            user_id:user_id,
            name:encodeURI(name)
          }
        })
      },
              // 导出记录
        downloadRecord(){
          this.exportConfirm()
        },
        // 按钮确定
        exportConfirm(){
          this.$getFile(`/v1/sport-evaluation?start_time=${this.time_slot[0]}&end_time=${this.time_slot[1]}&download_xls=1&time_name=${this.time_name}`, {})
            .then((res) => {
              console.log(res,'ressss')
              if (res.status === 200) {
                this.downloadFile(res.data)
              } else {
                this.$msg(res.statusText)
              }
            });
        },
        downloadFile(file){
          const blob = new Blob([file], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' }) // 构造一个blob对象来处理数据，并设置文件类型
          if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
            navigator.msSaveBlob(blob, this.filename)
          } else {
            const href = URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
            const a = document.createElement('a') //创建a标签
            a.style.display = 'none'
            a.href = href // 指定下载链接
            if (this.time_slot[0] && this.time_slot[1] && this.time_name == '') {
              a.download = '运动测评记录' + this.time_slot[0] + '-' + this.time_slot[1] + '.xlsx'
            } else if (this.time_slot[0] == '' && this.time_name == '') {
              a.download = '全部运动测评记录.xlsx';
            } else if (this.timeName !== '' && this.time_slot[0] == '') {
              a.download = this.timeName + '运动测评记录.xlsx';
            }
            a.click() //触发下载
            URL.revokeObjectURL(a.href) //释放URL对象
          }
        },
    },
    created() {
      this.getEvaluationList()
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .evaluation-list
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }
    .search
      margin 20px 0
      display flex
      justify-content flex-start
      input
        width 200px
        margin-right 20px
    .time-screen
      margin:20px 0;
      display flex
      align-items center
      >span
        margin-right: 10px;
        cursor pointer
      .time
        margin: 0 10px 0 40px;
    .list
      min-height 520px
      border 1px solid #EBEEF5
      .user_information
        color #00a0e9
        cursor pointer
    .block
      margin-top:10px;

    ::-webkit-scrollbar {
      display:block;
    }
    .el-table {
      .el-table__fixed,.el-table__fixed-right {
        height:auto !important;
        bottom:17px !important;
      }
    }
    //去掉固定列下方的横线
    .el-table__fixed::before, .el-table__fixed-right::before {
      display: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/SportsEvaluation/EvaluationList.vue